<div class="plate-container">
  <div class="col-left">
    <img
      src="./assets/imgs/iran-flag-dark.svg"
      alt="Iran Flag"
      class="flag-img"
    />
    <div class="zone-text">Q. SHIRIN</div>
  </div>

  <div class="col-middle">
    <div class="row-top">
      <input
        type="text"
        inputmode="numeric"
        [value]="toPersian(part1)"
        (input)="onPart1Input($event)"
        maxlength="5"
        placeholder="۱۲۳۴۵"
      />
    </div>
    <div class="row-bottom">
      <div class="english-numbers">{{ part1 || "12345" }}</div>
    </div>
  </div>

  <div class="col-right">
    <div class="row-top">
      <input
        #part2Input
        type="text"
        inputmode="numeric"
        [value]="toPersian(part2)"
        (input)="onPart2Input($event)"
        maxlength="2"
        placeholder="۸۸"
      />
    </div>
    <div class="row-bottom">
      <div class="english-numbers">{{ part2 || "88" }}</div>
    </div>
  </div>
</div>
